import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { environment, NavigationHistoryService, SHARED_CONFIG, ToastComponent } from '@pgaoc/shared-lib';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { provideToastr } from 'ngx-toastr';
import { InternalAuthInterceptor } from './core/interceptors/internal-auth-interceptor.service';
import { NgxFloatUiModule } from 'ngx-float-ui';
import { provideAnimations } from '@angular/platform-browser/animations';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideAnimations(), // required for toastr
    provideToastr({ toastComponent: ToastComponent }),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(MatIconModule),
    importProvidersFrom(NgxFloatUiModule),
    // computed: a Back cancelled by the discard-changes dialog puts the browser history back where it was
    provideRouter(routes, withRouterConfig({ canceledNavigationResolution: 'computed' })),
    // Created up front so it sees the first navigation
    provideAppInitializer(() => {
      inject(NavigationHistoryService);
    }),
    {
      provide: SHARED_CONFIG,
      useValue: {
        apiUrl: environment.mainServiceUrl,
        pgaEmail: environment.pgaEmail,
        pgaSiteUrl: environment.pgaSiteUrl,
        internalSiteUrl: environment.internalSiteUrl,
        memberSiteUrl: environment.memberSiteUrl,
        findAProProfileUrl: environment.findAProProfileUrl,
        extensionDays: environment.extensionDays,
        initialExpiryDays: environment.initialExpiryDays,
        maximumElectionMotions: environment.maximumElectionMotions,
        membersOnTheMoveFirstYear: environment.membersOnTheMoveFirstYear,
        imageRetryDelayMs: environment.imageRetryDelayMs,
        imageMaxRetries: environment.imageMaxRetries,
      },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InternalAuthInterceptor,
      multi: true,
    },
  ],
};
